// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {isEmpty} from 'lodash';
import classNames from 'classnames';
import {TripCard} from './TripCard/TripCard';
import './TripCards.less';

type photos = {
    uri: string,
};

type Address = {
    city: string,
    stateProvince: string,
};

type listing = {
    address?: Address,
    photos: Array<photos>,
};

type periodOfStay = {
    checkInDate: string,
    checkOutDate: string,
};

type StayDisplayStatus = {
    code?: string,
    description: string,
};

type payments = {
    status: string,
    title: string,
    viewUrl: string,
};
type priceDetails = {
    payments: payments,
};

type booking = {
    isPrimaryGuest?: boolean,
    listing: listing,
    periodOfStay?: periodOfStay,
    priceDetails?: priceDetails,
    uuid?: string,
};

export type TripDetails = {
    booking: booking,
    bookingState?: string,
    conversationId: string,
    stayDisplayStatus: StayDisplayStatus,
};

type props = {
    columns: number,
    heading: string,
    locale: string,
    translations: Object,
    trips: Array<TripDetails>,
    type: string,
};
export class TripCards extends React.PureComponent<props> {
    static propTypes = {
        columns: PropTypes.number,
        heading: PropTypes.string,
        locale: PropTypes.string,
        translations: PropTypes.shape({}),
        trips: PropTypes.arrayOf(PropTypes.shape({})),
        type: PropTypes.string,
    };

    static defaultProps = {
        columns: 2,
        translations: {},
    };

    get className() {
        return classNames('TripCards', {
            [`TripCards--${this.props.type}`]: this.props.type,
        });
    }

    renderTripCard = (tripDetails: TripDetails) => {
        const {locale, translations, type} = this.props;
        return (
            <TripCard
                key={tripDetails.conversationId}
                locale={locale}
                translations={translations}
                trip={tripDetails}
                type={type}
            />
        );
    };

    render() {
        if (isEmpty(this.props.trips)) {
            return null;
        }

        return (
            <section className={this.className}>
                <header className="TripCards__header">
                    <h2>{this.props.heading}</h2>
                </header>

                <div
                    key="tripCards_body"
                    className={`TripCards__body TripCards__body--${this.props.columns}`}
                >
                    {this.props.trips.map(this.renderTripCard)}
                </div>
            </section>
        );
    }
}
